// MEE BARSA — New Arrivals + Strip: shared scroll reveal
(function () {
  'use strict';

  if (window.__mbRevealBound) return;
  window.__mbRevealBound = true;

  var observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('in');
          observer.unobserve(entry.target);
        });
      }, { threshold: .15 })
    : null;

  function boot(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;

    var nodes = Array.prototype.slice.call(scope.querySelectorAll('.mb-reveal'));
    if (scope.matches && scope.matches('.mb-reveal')) nodes.unshift(scope);
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].dataset.mbRevealBound) continue;
      nodes[i].dataset.mbRevealBound = 'true';
      if (observer) observer.observe(nodes[i]);
      else nodes[i].classList.add('in');
    }
  }

  function unload(root) {
    if (!root || !root.querySelectorAll) return;

    var nodes = Array.prototype.slice.call(root.querySelectorAll('.mb-reveal[data-mb-reveal-bound]'));
    if (root.matches && root.matches('.mb-reveal[data-mb-reveal-bound]')) nodes.unshift(root);
    for (var i = 0; i < nodes.length; i++) {
      if (observer) observer.unobserve(nodes[i]);
      delete nodes[i].dataset.mbRevealBound;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    unload(event.target);
  });
})();
